var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAltOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66666V10.6667L8.00008 9.33333L5.33341 10.6667V2.66666M4.00008 13.3333H12.0001C12.3537 13.3333 12.6928 13.1929 12.9429 12.9428C13.1929 12.6928 13.3334 12.3536 13.3334 12V4C13.3334 3.64638 13.1929 3.30724 12.9429 3.05719C12.6928 2.80714 12.3537 2.66666 12.0001 2.66666H4.00008C3.64646 2.66666 3.30732 2.80714 3.05727 3.05719C2.80722 3.30724 2.66675 3.64638 2.66675 4V12C2.66675 12.3536 2.80722 12.6928 3.05727 12.9428C3.30732 13.1929 3.64646 13.3333 4.00008 13.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAltOutline);
export default __webpack_public_path__ + "static/media/BookmarkAltOutline.4611566d53388bdf6dac263872c8bb02.svg";
export { ForwardRef as ReactComponent };